import {FunctionComponent, ReactElement} from 'react'

interface IsDemoProps {
    children: (isDemo: boolean) => ReactElement | null
}

export const IsDemo: FunctionComponent<IsDemoProps> = ({children}) => (
    children(window.location.href.includes('#demo'))

);